import { Editor } from 'slate';
import { isVoidNode } from './isVoidNode.mjs';

function isRangeWithinVoid(editor, at = editor.selection) {
  if (!at) {
    return false;
  }
  const parent = Editor.above(editor, {
    at,
    voids: true
  });
  return parent ? isVoidNode(editor, parent[0]) : false;
}

export { isRangeWithinVoid };
